import { ReactComponent as CarIcon } from 'images/object-car.svg';
import { humanize } from 'utils';

import BaseTransportObject from './BaseTransportObject';

export default class Car extends BaseTransportObject {
  constructor({ model, engineVolume, ...config }) {
    super(config);

    this.icon = CarIcon;
    this.iconClass = 'icon_car';

    Object.assign(this, {
      model,
      engineVolume,
    });

    Object.assign(this.propertyTitles, {
      model: 'Марка/модель',
      horsepower: 'Мощность двигателя (л.с.)',
      engineVolume: 'Объем двигателя (куб.см.)',
    });

    Object.assign(this.propertyDisplayValueGetters, {
      engineVolume: () => humanize(this.engineVolume),
    });
  }

  static typeTitle = 'Наземный транспорт';

  getTypeTitle() {
    return Car.typeTitle;
  }

  getTitle() {
    return this.title || `${this.model || ''} ${this.registrationSign || ''}`;
  }

  getName() {
    return `${this.model || ''} ${this.registrationSign || ''}`;
  }

  getPdfTitle() {
    return `${super.getPdfTitle()}, ${this.model}`;
  }

  isCar() {
    return true;
  }
}
